import StatusCounter from './StatusCounter';

export default StatusCounter;
